<div><label>{{ 'Volunteer.OnlineFormSignLabel' |  translate}}</label></div> 
<div class="buttons flex justify-between sign-pad-container"> 
  <canvas #canvas width="350" height="65"></canvas>
  <button mat-raised-button (click)="clearPad()" color="primary">Clear</button>
</div>